__turbopack_context__.v({
  "root": "styles-module-scss-module__1rZUhq__root",
  "text": "styles-module-scss-module__1rZUhq__text",
});
